import useStartCompanyScanFlow from '../../../company-scan/hooks/useStartCompanyScanFlow';
import useStartAskaTravelContractFlow from '../../../risk-analysis/src/hooks/useStartAskaTravelContractFlow';
import useStartAskaTravelOfferFlow from '../../../risk-analysis/src/hooks/useStartAskaTravelOfferFlow';
import useStartCfInsurancesFlow from '../../../risk-analysis/src/hooks/useStartCfInsurancesFlow';
import useStartCitizinsTravelOfferFlow from '../../../risk-analysis/src/hooks/useStartCitizinsTravelOfferFlow';
import useStartRiskAnalysisFlow from '../../../risk-analysis/src/hooks/useStartRiskAnalysisFlow';
import useStartShortCheckupCompanyFlow from '../../../risk-analysis/src/hooks/useStartShortCheckupCompanyFlow';
import useStartShortCheckupCustomerFlow from '../../../risk-analysis/src/hooks/useStartShortCheckupCustomerFlow';
import useStartBikmoContractFlow from '../../../sales-conversation/src/hooks/bikmo/useStartBikmoContractFlow';
import useStartBikmoOfferFlow from '../../../sales-conversation/src/hooks/bikmo/useStartBikmoOfferFlow';
import useStartPiaBoatContractFlow from '../../../sales-conversation/src/hooks/boat/useStartPiaBoatContractFlow';
import useStartPiaBoatOfferFlow from '../../../sales-conversation/src/hooks/boat/useStartPiaBoatOfferFlow';
import useStartCyclingVlaanderenContractFlow from '../../../sales-conversation/src/hooks/cycling-vlaanderen/useStartCyclingVlaanderenContractFlow';
import useStartCyclingVlaanderenOfferFlow from '../../../sales-conversation/src/hooks/cycling-vlaanderen/useStartCyclingVlaanderenOfferFlow';
import useStartDefaultSalesConversationFlow from '../../../sales-conversation/src/hooks/default/useStartDefaultSalesConversationFlow';
import useStartDeMotoVerzekeringFlow from '../../../sales-conversation/src/hooks/useStartDeMotoVerzekeringFlow';
import useStartSalesConversationFlow from '../../../sales-conversation/src/hooks/useStartSalesConversationFlow';
import useStartVillasureContractFlow from '../../../sales-conversation/src/hooks/villasure/useStartVillasureContractFlow';
import useStartVillasureOfferFlow from '../../../sales-conversation/src/hooks/villasure/useStartVillasureOfferFlow';
import useStartYellowhiveFlow from '../hooks/flows-configure/useStartYellowhiveFlow';
import {
  flowIdBikmoContractFlow,
  flowIdBikmoOfferFlow,
  flowIdCompanyScanBE,
  flowIdCompanyScanNL,
  flowIdCyclingVlaanderenContractFlowId,
  flowIdCyclingVlaanderenOfferFlowId,
  flowIdDeMotoVerzekering,
  flowIdLoonzorgNederlandFlowId,
  flowIdPiaBoatContractFlow,
  flowIdPiaBoatOfferFlow,
  flowIdRiskAnalysisBE,
  flowIdRiskAnalysisNL,
  flowIdRiskAnalysisShortBE,
  flowIdSalesConversation,
  flowIdVillasureContractFlow,
  flowIdShortCheckupCompanyNL,
  flowIdVillasureOfferFlow,
  flowIdShortCheckupCustomerNL,
  flowIdCfVerzekeringen,
  flowIdAskaTravelOffer,
  flowIdAskaTravelContract,
  flowIdShortCheckupCustomerBE,
  flowIdShortCheckupCompanyBE,
  flowIdCitizinsTravel,
  flowIdGoudseCompanyScan,
  flowIdYellowHiveCustomerOffer,
  flowIdYellowHiveCompanyOffer,
} from '../constants/flowIds';

interface StartFlowProps {
  flowId: string;
  sessionId: string;
  inputUrl?: string;
  partyId?: string;
  quoteId?: string;
  quoteIds?: string[];
}

const useStartFlow = () => {
  const startCompanyScanFlow = useStartCompanyScanFlow();
  const startRiskAnalysisFlow = useStartRiskAnalysisFlow();
  const startSalesConversation = useStartSalesConversationFlow();
  const startDeMotoVerzekeringFlow = useStartDeMotoVerzekeringFlow();
  const startVillasureOfferFlow = useStartVillasureOfferFlow();
  const startVillasureContractFlow = useStartVillasureContractFlow();
  const startPiaBoatOfferFlow = useStartPiaBoatOfferFlow();
  const startPiaBoatContractFlow = useStartPiaBoatContractFlow();
  const startBikmoOfferFlow = useStartBikmoOfferFlow();
  const startBikmoContractFlow = useStartBikmoContractFlow();
  const startCyclingVlaanderenOfferFlow = useStartCyclingVlaanderenOfferFlow();
  const startCyclingVlaanderenContractFlow =
    useStartCyclingVlaanderenContractFlow();
  const startShortCheckupCompanyFlow = useStartShortCheckupCompanyFlow();
  const startShortCheckupCustomerFlow = useStartShortCheckupCustomerFlow();
  const startCfInsurancesFlow = useStartCfInsurancesFlow();
  const startAskaTravelOfferFlow = useStartAskaTravelOfferFlow();
  const startCitizinsTravelOfferFlow = useStartCitizinsTravelOfferFlow();
  const startAskaTravelContractFlow = useStartAskaTravelContractFlow();
  const startDefaultSalesConversation = useStartDefaultSalesConversationFlow();
  const startYellowhiveFlow = useStartYellowhiveFlow();
  const startFlow = ({
    flowId,
    sessionId,
    inputUrl,
    partyId,
    quoteId,
    quoteIds,
  }: StartFlowProps) => {
    switch (flowId) {
      case flowIdRiskAnalysisNL:
      case flowIdRiskAnalysisBE:
      case flowIdRiskAnalysisShortBE:
        startRiskAnalysisFlow(sessionId);
        break;
      case flowIdSalesConversation:
        startSalesConversation(sessionId);
        break;
      case flowIdDeMotoVerzekering:
        startDeMotoVerzekeringFlow(sessionId);
        break;
      case flowIdVillasureOfferFlow:
        startVillasureOfferFlow(sessionId);
        break;
      case flowIdVillasureContractFlow:
        startVillasureContractFlow(sessionId, inputUrl, partyId, quoteId);
        break;
      case flowIdPiaBoatOfferFlow:
        startPiaBoatOfferFlow(sessionId);
        break;
      case flowIdPiaBoatContractFlow:
        startPiaBoatContractFlow(sessionId, inputUrl, partyId, quoteId);
        break;
      case flowIdBikmoOfferFlow:
        startBikmoOfferFlow(sessionId);
        break;
      case flowIdBikmoContractFlow:
        startBikmoContractFlow(sessionId, inputUrl, partyId, quoteId);
        break;
      case flowIdCyclingVlaanderenOfferFlowId:
        startCyclingVlaanderenOfferFlow(sessionId);
        break;
      case flowIdCyclingVlaanderenContractFlowId:
        startCyclingVlaanderenContractFlow(
          sessionId,
          inputUrl,
          partyId,
          quoteId,
        );
        break;
      case flowIdShortCheckupCompanyNL:
      case flowIdShortCheckupCompanyBE:
        startShortCheckupCompanyFlow(sessionId, inputUrl, partyId, quoteId);
        break;
      case flowIdShortCheckupCustomerNL:
      case flowIdShortCheckupCustomerBE:
        startShortCheckupCustomerFlow(sessionId, inputUrl, partyId, quoteId);
        break;
      case flowIdCfVerzekeringen:
        startCfInsurancesFlow(sessionId, inputUrl, partyId, quoteId);
        break;
      case flowIdAskaTravelOffer:
        startAskaTravelOfferFlow(sessionId, inputUrl, partyId, quoteId);
        break;
      case flowIdAskaTravelContract:
        startAskaTravelContractFlow(sessionId, inputUrl, partyId, quoteIds);
        break;
      case flowIdCitizinsTravel:
        startCitizinsTravelOfferFlow(sessionId, inputUrl, partyId, quoteId);
        break;
      case flowIdCompanyScanBE:
      case flowIdCompanyScanNL:
      case flowIdGoudseCompanyScan:
        startCompanyScanFlow(sessionId, partyId, undefined, flowId);
        break;
      case flowIdLoonzorgNederlandFlowId:
        startDefaultSalesConversation({
          uuid: sessionId,
          flowId,
          partyId,
          quoteId,
          quoteIds,
        });
        break;
      case flowIdYellowHiveCustomerOffer:
      case flowIdYellowHiveCompanyOffer:
        startYellowhiveFlow({
          flowId,
          uuid: sessionId,
          inputUrl,
          partyId,
          quoteId,
          quoteIds,
        });
        break;
      default:
        startDefaultSalesConversation({
          uuid: sessionId,
          flowId,
          partyId,
          quoteId,
          quoteIds,
        });
        console.error(`Flow with id ${flowId} not found`);
    }
  };

  return startFlow;
};

export default useStartFlow;
